import styled from 'styled-components'

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	column-gap: 6px;
	margin-bottom: 16px;
`
